import { BigNumber as NS } from 'bignumber.js';
import * as Sentry from '@sentry/vue';
import { getCloseRecordById } from '../../utils/itemClose';
var ServerSections;
(function (ServerSections) {
    ServerSections["spot"] = "spot";
    ServerSections["futures"] = "futures";
})(ServerSections || (ServerSections = {}));
var Sections;
(function (Sections) {
    Sections["spot"] = "\u0421\u043F\u043E\u0442";
    Sections["futures"] = "\u0424\u044C\u044E\u0447\u0435\u0440\u0441";
})(Sections || (Sections = {}));
var TransferSides;
(function (TransferSides) {
    TransferSides["long"] = "\u041B\u043E\u043D\u0433";
    TransferSides["short"] = "\u0428\u043E\u0440\u0442";
})(TransferSides || (TransferSides = {}));
export const setTrueFieldsNamesPositions = (list) => {
    return list.reduce((acc, curr) => {
        const body = {
            ticker: curr.symbol,
            positionPrice: NS(curr.price),
            volume: NS(curr.amount).abs(),
            currentPrice: NS(curr.currentPrice),
            result: NS(curr.result),
            direction: curr.side === 'BUY' ? TransferSides.long : TransferSides.short,
            closing: false
        };
        if (body.currentPrice.isZero()) {
            // @ts-ignore
            Sentry.captureException(new Error('CP0 setTrueFieldsNamesPositions'), { extra: { item: curr } });
        }
        if (body.result.isNaN()) {
            // @ts-ignore
            Sentry.captureException(new Error('NaN setTrueFieldsNamesPositions'), { extra: { item: curr } });
        }
        acc.push(body);
        return acc;
    }, []);
};
export const resolveActionTypeOnPositions = (list, item) => {
    const findedIndex = list.findIndex((positionsItem) => positionsItem.ticker === item.ticker);
    const positionsItem = list[findedIndex];
    if (findedIndex >= 0) {
        let totalQuantity = NS(0);
        if (positionsItem.direction === item.direction) {
            totalQuantity = positionsItem.volume.plus(item.volume);
        }
        else
            totalQuantity = positionsItem.volume.minus(item.volume);
        if (!totalQuantity.isZero())
            return 'updateItemInPositions';
        return 'removeItemInPositions';
    }
    const ghostPosition = getCloseRecordById(item.ticker);
    if (ghostPosition !== undefined) {
        if (!ghostPosition.binance && ghostPosition.wl) {
            if (ghostPosition.item.direction !== item.direction) {
                if (ghostPosition.item.volume.minus(item.volume).isZero()) {
                    return 'removeItemInPositions';
                }
            }
        }
    }
    return 'pushItemInPosiions';
};
